import { createContext, useContext, useLayoutEffect, useRef,  } from 'react'

import { localAccessors } from '@utils/localStateAccess'
import usePostStatsContext from './postStatsContext'
import useCheckButton from '@hooks/useCheckButton'
import useModalContext from './modalContext'
import useFeed from '@hooks/useFeed';

const FollowingFeedContext = createContext();
const FollowingFeedProvider = ({ children }) => {
  const { followingFeed } = localAccessors
  const postStats = usePostStatsContext()
  const { setNewPostCallbackRef } = useModalContext()
  const firstProviderRender = useRef(true)

  //// FOLLOWING FEED CONFIG
  const followingFeedRef = useRef()
  // Feed State/Utilities
  const followingFeedState = useFeed({ getPostsUrl: '/api/feeds/following_posts', feedAccessor: followingFeed(), postStats })
  // CheckPostButton state
  const followingCheckPostsButton = useCheckButton({ getDataOnClick: followingFeedState.getPosts })

  // sets timeout for check posts button on initial render
  useLayoutEffect(() => {
    if (firstProviderRender.current) {
      followingCheckPostsButton.setCheckPostsTimeout(10000)
      firstProviderRender.current = false
    }
  }, [])

  // TOD: this needs to change
  useLayoutEffect(() => {
    setNewPostCallbackRef((newPost) => {
      if (newPost) {
        followingFeedState?.addPostToFeedStart?.(newPost)
        // nearbyFeedState?.addPostToFeedStart?.(newPost)
      }
    })
  }, [])

  return (
    <FollowingFeedContext.Provider value={{
      feedRef: followingFeedRef,
      feedState: followingFeedState,
      checkPostsButton: followingCheckPostsButton,
    }}>
      {children}
    </FollowingFeedContext.Provider>
  )
}

const useFollowingFeedContext = () => useContext(FollowingFeedContext)

export default useFollowingFeedContext

export { FollowingFeedContext, FollowingFeedProvider, useFollowingFeedContext }
